import type { Sections } from '../types/tools';

/**
 * Navigation tree defining the two top-level sections (leadership &
 * teamship), their categories, and the tools within each category.
 *
 * Extracted from index.original.html (lines 997-1053).
 */
export const SECTIONS: Sections = {
  leadership: {
    label: 'Teamship Tools',
    cats: {
      'personal-development': {
        label: 'Personal Development & Purpose',
        icon: 'compass',
        tools: {
          'strengths-workons': { l: 'Strengths and Work-ons' },
          'player-captain-coach': { l: 'Player Captain Coach' },
          'my-next-chapter': { l: 'My Next Chapter' },
        },
      },
      'wellbeing': {
        label: 'Well-being & Self-care',
        icon: 'heart',
        tools: {
          'resilience-audit': { l: 'Resilience Audit' },
          'drivers-belonging': { l: 'Drivers of Belonging' },
          'energy-givers-sappers': { l: 'Energy Givers & Sappers' },
          'psychological-safety': { l: 'Drivers of Psychological Safety' },
        },
      },
      'prioritisation': {
        label: 'Prioritisation',
        icon: 'grid',
        tools: {
          'abcd': { l: 'ABCD' },
          'perform-transform': { l: 'Perform and Transform' },
          'goals-barriers': { l: 'Goals and Barriers' },
          'ai-matrix': { l: 'The AI Matrix' },
        },
      },
      'strategy': {
        label: 'Strategy',
        icon: 'target',
        tools: {
          'mission-strategy-tactics': { l: 'Mission Strategy Tactics' },
          'nasard': { l: 'The NASARD Differentiators' },
          'reduce-simplify': { l: 'Reduce and Simplify' },
        },
      },
      'feedback': {
        label: 'Feedback',
        icon: 'msg',
        tools: {
          'know-about-me': { l: 'Some Things You Should Know About Me' },
          'relationship-resets': { l: 'Relationship Resets' },
        },
      },
    },
  },
  teamship: {
    label: 'Teamship Tools',
    cats: {
      'codifying': {
        label: 'Codifying & Contracting',
        icon: 'clip',
        tools: {
          'teamship-charter': { l: 'The Teamship Charter' },
          'one-on-one': { l: 'One-on-One Contracting' },
          'teamship-contract': { l: 'The Teamship Contract' },
          'start-stop-double': { l: 'Start-Stop-Double Down' },
          'inter-team-contracting': { l: 'Inter Team Contracting' },
        },
      },
      'reviewing': {
        label: 'Reviewing & Resetting',
        icon: 'refresh',
        tools: {
          'teamship-audit': { l: 'The Teamship Audit' },
          'exco-audit': { l: 'The ExCo Audit' },
          'hot-debrief': { l: 'Hot Debrief' },
        },
      },
      'meetings': {
        label: 'Meetings & Infrastructure',
        icon: 'users',
        tools: {
          'forums-upgrade': { l: 'Forums Upgrade' },
          'meeting-pyramid': { l: 'The Meeting Pyramid' },
        },
      },
      'innovation': {
        label: 'Innovation & Decision-making',
        icon: 'bulb',
        tools: {
          'four-q': { l: 'Four Q Decision Making' },
          'brainstrust': { l: 'BrainsTrust' },
        },
      },
      'getting-to-know': {
        label: 'Getting to Know Each Other',
        icon: 'people',
        tools: {
          'backstories': { l: 'Backstories' },
          'boom': { l: 'Boom' },
          'fifty-questions': { l: '50 Questions' },
          'dev-accelerator': { l: 'Development Accelerator' },
        },
      },
    },
  },
};
